import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AddExternalBankAccountRequest,
  CreateStripeAccountRequest,
  GenerateOnboardingLinkRequest,
  GenerateOnboardingLinkResponse,
  StripeConnectedAccount
} from '@umss/shared/data-access';

@Injectable({ providedIn: 'root' })
export class ContractorStripeService {
  private readonly baseUrl = '/api/contractors/me/stripe';

  private readonly http = inject(HttpClient);

  createAccount(
    body: CreateStripeAccountRequest = {}
  ): Observable<StripeConnectedAccount> {
    return this.http.post<StripeConnectedAccount>(
      `${this.baseUrl}/account`,
      body
    );
  }

  getAccountStatus(): Observable<StripeConnectedAccount> {
    return this.http.get<StripeConnectedAccount>(`${this.baseUrl}/account`);
  }

  generateOnboardingLink(
    body: GenerateOnboardingLinkRequest
  ): Observable<GenerateOnboardingLinkResponse> {
    return this.http.post<GenerateOnboardingLinkResponse>(
      `${this.baseUrl}/onboarding-link`,
      body
    );
  }

  addExternalBankAccount(
    body: AddExternalBankAccountRequest
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.baseUrl}/external-bank-account`,
      body
    );
  }

  deleteAccount(contractorId: string): Observable<void> {
    return this.http.delete<void>(
      `/api/contractors/${contractorId}/stripe/account`
    );
  }
}
